import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { DashboardState } from '../../../models';

const DEFAULT_SUPPORT_URL = 'https://helpdesk.trustflight.com/hc/en-gb';

/**
 * Gets the support URL based on state operator settings.
 *
 * Rules:
 * - If all operators have the same URL, returns that URL
 * - If operators have different URLs, returns the default TrustFlight URL
 *
 * @returns {string} The support URL to use
 */
export default function useSupportUrl(): string {
  const { userSettings } = useSelector((state: DashboardState) => state);

  return useMemo(() => {
    const operators = userSettings?.details?.operators ?? [];

    if (operators.length === 0) {
      return DEFAULT_SUPPORT_URL;
    }

    const supportUrls = operators.map((op) => op.operator_setting?.support_url ?? '');
    const firstUrl = supportUrls[0];
    const allUrlsMatch = supportUrls.every((url) => url === firstUrl);

    if (allUrlsMatch) {
      return firstUrl;
    }

    return DEFAULT_SUPPORT_URL;
  }, [userSettings]);
}

